import { render, staticRenderFns } from "./RelateProjectInfo.vue?vue&type=template&id=05edc864&scoped=true"
import script from "./RelateProjectInfo.vue?vue&type=script&lang=js"
export * from "./RelateProjectInfo.vue?vue&type=script&lang=js"
import style0 from "./RelateProjectInfo.vue?vue&type=style&index=0&id=05edc864&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05edc864",
  null
  
)

export default component.exports